import {
  chakra,
  Divider,
  Flex,
  Heading
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  calculateDefaultValues,
  generateArrayOfYears,
  translateSubElementString
} from "../../../utils";
import { Page } from "../../../components/Page";
import { Card } from "../../../components/Card";
import { FormSelect } from "../../../components/Forms";
import { SuppliersDataReport } from "./components/SuppliersDataReport";
import { WithAuthorization } from "../../../context";

function SupplierReports() {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  const {
    register,
    formState: { errors },
    watch
  } = useForm({
    defaultValues: calculateDefaultValues()
  });

  const watchYear = watch("financialYear");
  const watchQuarter = watch("quarter");

  return (
    <Page title={t("supplierReports.page.title")}
          subTitle={translateSubElementString("reportsPage.supplierReports.page.subTitle")}>
      <Card>
        <Heading size="md" marginBlock="1">
          {t("selectPeriod")}
        </Heading>
        <chakra.form id="calculateReport">
          <Flex gap="4" marginBlockStart="5" alignItems="end" justifyContent="space-between">
            <Flex width="50%" gap="4">
              <FormSelect
                label={t("inputs.financialYear")}
                errors={errors}
                {...register("financialYear", { required: true })}
              >
                {generateArrayOfYears().map((year) => <option key={year} value={year}>{year}</option>)}
              </FormSelect>
              <FormSelect
                label={t("inputs.quarter")}
                errors={errors}
                {...register("quarter", { required: true })}
              >
                <option key="ALL" value="ALL">ALL</option>
                <option key="Q1" value="Q1">Q1</option>
                <option key="Q2" value="Q2">Q2</option>
                <option key="Q3" value="Q3">Q3</option>
                <option key="Q4" value="Q4">Q4</option>
              </FormSelect>
            </Flex>
          </Flex>
        </chakra.form>
      </Card>
      <Divider marginBlock="5" />
      <Card>
        <SuppliersDataReport year={watchYear} quarter={watchQuarter} />
      </Card>
    </Page>
  );
}

export default WithAuthorization(SupplierReports);